/**
 * input[type=month] 가 쓰는 YYYY-MM 문자열 유틸.
 *
 * 별도 파일로 뺀 이유는 테스트하기 위해서다.
 * 컴포넌트 안에 두면 렌더링 없이 검증할 방법이 없는데,
 * 여기서 틀리면 1~9월 내내 조회가 조용히 어긋난다.
 */

/** 이번 달을 YYYY-MM 으로. */
export function currentMonth(now: Date = new Date()): string {
  return toMonthValue(now);
}

/**
 * Date 를 YYYY-MM 으로 바꾼다.
 *
 * 🔴 getMonth() 는 0부터 센다. +1 을 빠뜨리면 한 달 앞의 데이터를 보게 되고,
 *   화면은 아무 오류 없이 틀린 달을 맞다고 보여준다.
 *
 * 🔴 자리수를 채우지 않으면 1~9월이 "2026-8" 이 된다.
 *   input[type=month] 가 값을 인식하지 못해 칸이 비어 보이고,
 *   서버의 YearMonth.parse 도 실패한다.
 *
 * toISOString() 을 쓰지 않는 이유
 *   그것은 UTC 기준이다. KST 기준 매월 1일 오전 9시 이전에는 지난달이 나온다.
 *   지역 시각 그대로 읽어야 한다.
 */
export function toMonthValue(date: Date): string {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
}
